import ApiService from "@/services/api.service.js";

export const LogMonitoringService = {
    addIndicator: function(data) {
        // debugger;
        return ApiService.post("/add-indicator", data);
    },
    updateIndicator: function(data) {
        return ApiService.post("/update-indicator", data);
    },
    deleteIndicator: function(data) {
        return ApiService.post("/delete-indicator", data);
    },
    getIndicators: function(data) {
        if (data) {
            return ApiService.get(
                `/indicators?per_page=${data.per_page}&page=${data.page}`
            );
        } else {
            return ApiService.get(
                `/indicators`
            );
        }
    },
    getIndicator: function(data) {
        return ApiService.get(`/indicator?id=${data}`);
    },
    getIndicatortypes: function(data) {
        return ApiService.get(`/indicator-types`);
    },
    getIndicatortype: function(data) {
        return ApiService.get(`/indicator-type?id=${data}`);
    },
    getApplications: function(data) {
        return ApiService.post(
            `/indicator-applications`, data
        );
    },
    getIndicatormetric: function(data) {
        return ApiService.get(
            `/indicator-metric?indicator_id=${data.indicator_id}`
        );
    },
    addApplicationIndicator: function(data) {
        return ApiService.post(`/add-application-indicator`, data);
    },
    getApplicationIndicators: function(data) {
        return ApiService.get(
            `/application-indicator-details?application_id=${data.applicationId}`
        );
    },
    getApplicationDetails: function(data) {
        return ApiService.get(
            `/application-details?application_id=${data.applicationId}`
        );
    },
    getAllIndicators: function(data) {
        return ApiService.get(`/application-indicators`);
    },
    updateApplicationIndicator: function(data) {
        return ApiService.post(`/update-application-indicator`, data);
    },
    deleteApplicationIndicator: function(data) {
        return ApiService.post(`/delete-application-indicator`, data);
    },
    getFilters: function(data) {
        // grant, regions, indicator, country, application
        return ApiService.post(`/application-indicators-filters`, data);
    },
    getFilteredIndicators: function(data) {
        // return ApiService.post(
        //     `/application-indicator-details`, data
        // );
        return ApiService.get(
            `/application-indicators?grant=${data.grant}&application=${data.application}&country=${data.country}&regions=${data.regions}&indicator=${data.indicator}&per_Page=${data.per_page}&page=${data.page}`
            // `/application-indicators?grant=${data.grant}&application=${data.application}&country=${data.country}&regions=${data.regions}&indicator=${data.indicator}`
        );
    },
    exportApplicationIndicator: function(data) {
        // for (const property in data) {
        //     console.log(`${property}: ${data[property]}`);
        // }
        return ApiService.get(
            `/export-application-indicator?grant_id=${data.grant_id}&application_id=${data.application_id}&country_id=${data.country_id}&region_id=${data.region_id}&indicator_id=${data.indicator_id}`
        );
    },
};

export default LogMonitoringService;